import React from "react";
import { connect } from "react-redux";
import { withRouter } from "../../utils/withRouter";
import AggregatorCollections from "../../components/AggregatorCollection/AggregatorCollections";
import { DashboardHeader } from "../../components/Header";

class AggregatorCollectionsScreen extends React.Component {
  render() {
    const { searchParams } = this.props;

    const aggregatorId = searchParams.get("agId");
    const aggregatorName = searchParams.get("agName");
    return (
      <div className="card">
        <div className="card-body">
          <DashboardHeader
            title={aggregatorName + " collections"}
            titleClassName="text-primary"
          />
          <AggregatorCollections
            showAdd
            aggregatorId={aggregatorId}
            aggregatorName={aggregatorName}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(
  withRouter(AggregatorCollectionsScreen)
);
